import * as Types from '../../types/generated';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetSuggestionsForCompanyQueryVariables = Types.Exact<{
  query: Types.Scalars['String']['input'];
  count: Types.Scalars['Int']['input'];
  session: Types.Scalars['String']['input'];
  countryCode2?: Types.InputMaybe<Types.Scalars['CountryCodeIso2']['input']>;
  languageCode?: Types.InputMaybe<Types.Scalars['LanguageCodeIso']['input']>;
}>;

export type GetSuggestionsForCompanyQuery = {
  ontologyOrganisations: Array<{ id: string; normalisedText: string }>;
};

export const GetSuggestionsForCompanyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getSuggestionsForCompany' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'query' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'count' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'session' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'countryCode2' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'CountryCodeIso2' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'languageCode' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'LanguageCodeIso' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ontologyOrganisations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'query' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'query' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'count' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'count' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'session' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'session' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'countryCode2' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'countryCode2' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'languageCode' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'languageCode' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'normalisedText' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetSuggestionsForCompanyQuery__
 *
 * To run a query within a React component, call `useGetSuggestionsForCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuggestionsForCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuggestionsForCompanyQuery({
 *   variables: {
 *      query: // value for 'query'
 *      count: // value for 'count'
 *      session: // value for 'session'
 *      countryCode2: // value for 'countryCode2'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useGetSuggestionsForCompanyQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSuggestionsForCompanyQuery,
    GetSuggestionsForCompanyQueryVariables
  > &
    (
      | { variables: GetSuggestionsForCompanyQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSuggestionsForCompanyQuery,
    GetSuggestionsForCompanyQueryVariables
  >(GetSuggestionsForCompanyDocument, options);
}
export function useGetSuggestionsForCompanyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSuggestionsForCompanyQuery,
    GetSuggestionsForCompanyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSuggestionsForCompanyQuery,
    GetSuggestionsForCompanyQueryVariables
  >(GetSuggestionsForCompanyDocument, options);
}
export function useGetSuggestionsForCompanySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSuggestionsForCompanyQuery,
        GetSuggestionsForCompanyQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSuggestionsForCompanyQuery,
    GetSuggestionsForCompanyQueryVariables
  >(GetSuggestionsForCompanyDocument, options);
}
export type GetSuggestionsForCompanyQueryHookResult = ReturnType<
  typeof useGetSuggestionsForCompanyQuery
>;
export type GetSuggestionsForCompanyLazyQueryHookResult = ReturnType<
  typeof useGetSuggestionsForCompanyLazyQuery
>;
export type GetSuggestionsForCompanySuspenseQueryHookResult = ReturnType<
  typeof useGetSuggestionsForCompanySuspenseQuery
>;
export type GetSuggestionsForCompanyQueryResult = Apollo.QueryResult<
  GetSuggestionsForCompanyQuery,
  GetSuggestionsForCompanyQueryVariables
>;
